module.exports = __webpack_public_path__ + "img/vimc accelerating-digital-transformation.3d699399.png";